/**
 * component to render in nominations tab at How to Nominate page
 */
const NominationsSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-50 px-5 py-4 font-public-sans">
      Nominations are now closed
    </div>
  );
};

export default NominationsSection;
